/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseServiceUrl } from '../base-service-url';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { dismissNotification } from '../fn/notification/dismiss-notification';
import { DismissNotification$Params } from '../fn/notification/dismiss-notification';
import { enableNotification } from '../fn/notification/enable-notification';
import { EnableNotification$Params } from '../fn/notification/enable-notification';
import { getMyNotifications } from '../fn/notification/get-my-notifications';
import { GetMyNotifications$Params } from '../fn/notification/get-my-notifications';
import { isActive } from '../fn/notification/is-active';
import { IsActive$Params } from '../fn/notification/is-active';
import { markAsSeen } from '../fn/notification/mark-as-seen';
import { MarkAsSeen$Params } from '../fn/notification/mark-as-seen';
import { Notification } from '../models/notification';
import { sendNotification } from '../fn/notification/send-notification';
import { SendNotification$Params } from '../fn/notification/send-notification';
import { sendNotificationByTitle } from '../fn/notification/send-notification-by-title';
import { SendNotificationByTitle$Params } from '../fn/notification/send-notification-by-title';
import { setMyFacilityNotificationAsRead } from '../fn/notification/set-my-facility-notification-as-read';
import { SetMyFacilityNotificationAsRead$Params } from '../fn/notification/set-my-facility-notification-as-read';
import { setMyNotificationAsRead } from '../fn/notification/set-my-notification-as-read';
import { SetMyNotificationAsRead$Params } from '../fn/notification/set-my-notification-as-read';
import { updateNotification } from '../fn/notification/update-notification';
import { UpdateNotification$Params } from '../fn/notification/update-notification';
import { updateNotificationByTitle } from '../fn/notification/update-notification-by-title';
import { UpdateNotificationByTitle$Params } from '../fn/notification/update-notification-by-title';

@Injectable({ providedIn: 'root' })
export class NotificationService extends BaseServiceUrl {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getMyNotifications()` */
  static readonly GetMyNotificationsPath = '/api/notification';

  /**
   * Get My Notifications.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMyNotifications()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMyNotifications$Response(params?: GetMyNotifications$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Notification>>> {
    return getMyNotifications(this.http, this.rootUrl, params, context);
  }

  /**
   * Get My Notifications.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMyNotifications$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMyNotifications(params?: GetMyNotifications$Params, context?: HttpContext): Observable<Array<Notification>> {
    return this.getMyNotifications$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Notification>>): Array<Notification> => r.body)
    );
  }

  /** Path part for operation `dismissNotification()` */
  static readonly DismissNotificationPath = '/api/notification/dismiss/{facilityGroupId}/{type}';

  /**
   * Dismiss Notification.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dismissNotification()` instead.
   *
   * This method doesn't expect any request body.
   */
  dismissNotification$Response(params: DismissNotification$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return dismissNotification(this.http, this.rootUrl, params, context);
  }

  /**
   * Dismiss Notification.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dismissNotification$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dismissNotification(params: DismissNotification$Params, context?: HttpContext): Observable<void> {
    return this.dismissNotification$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `isActive()` */
  static readonly IsActivePath = '/api/notification/isactive';

  /**
   * Is Active.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `isActive()` instead.
   *
   * This method doesn't expect any request body.
   */
  isActive$Response(params?: IsActive$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return isActive(this.http, this.rootUrl, params, context);
  }

  /**
   * Is Active.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `isActive$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  isActive(params?: IsActive$Params, context?: HttpContext): Observable<boolean> {
    return this.isActive$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `markAsSeen()` */
  static readonly MarkAsSeenPath = '/api/notification/markAsSeen';

  /**
   * Mark As Seen.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `markAsSeen()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  markAsSeen$Response(params: MarkAsSeen$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Notification>>> {
    return markAsSeen(this.http, this.rootUrl, params, context);
  }

  /**
   * Mark As Seen.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `markAsSeen$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  markAsSeen(params: MarkAsSeen$Params, context?: HttpContext): Observable<Array<Notification>> {
    return this.markAsSeen$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Notification>>): Array<Notification> => r.body)
    );
  }

  /** Path part for operation `sendNotification()` */
  static readonly SendNotificationPath = '/api/notification/send';

  /**
   * Send Notification.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendNotification()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendNotification$Response(params?: SendNotification$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return sendNotification(this.http, this.rootUrl, params, context);
  }

  /**
   * Send Notification.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sendNotification$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendNotification(params?: SendNotification$Params, context?: HttpContext): Observable<void> {
    return this.sendNotification$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `sendNotificationByTitle()` */
  static readonly SendNotificationByTitlePath = '/api/notification/send/{title}';

  /**
   * Send Notification By Title.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendNotificationByTitle()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendNotificationByTitle$Response(params: SendNotificationByTitle$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return sendNotificationByTitle(this.http, this.rootUrl, params, context);
  }

  /**
   * Send Notification By Title.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sendNotificationByTitle$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendNotificationByTitle(params: SendNotificationByTitle$Params, context?: HttpContext): Observable<void> {
    return this.sendNotificationByTitle$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateNotification()` */
  static readonly UpdateNotificationPath = '/api/notification/update';

  /**
   * Update Notification.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateNotification()` instead.
   *
   * This method doesn't expect any request body.
   */
  updateNotification$Response(params?: UpdateNotification$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Notification>>> {
    return updateNotification(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Notification.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateNotification$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  updateNotification(params?: UpdateNotification$Params, context?: HttpContext): Observable<Array<Notification>> {
    return this.updateNotification$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Notification>>): Array<Notification> => r.body)
    );
  }

  /** Path part for operation `updateNotificationByTitle()` */
  static readonly UpdateNotificationByTitlePath = '/api/notification/update/{title}';

  /**
   * Update Notification By Title.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateNotificationByTitle()` instead.
   *
   * This method doesn't expect any request body.
   */
  updateNotificationByTitle$Response(params: UpdateNotificationByTitle$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Notification>>> {
    return updateNotificationByTitle(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Notification By Title.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateNotificationByTitle$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  updateNotificationByTitle(params: UpdateNotificationByTitle$Params, context?: HttpContext): Observable<Array<Notification>> {
    return this.updateNotificationByTitle$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Notification>>): Array<Notification> => r.body)
    );
  }

  /** Path part for operation `enableNotification()` */
  static readonly EnableNotificationPath = '/api/notification/{facilityId}/enableNotification';

  /**
   * Enable Notification.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `enableNotification()` instead.
   *
   * This method doesn't expect any request body.
   */
  enableNotification$Response(params: EnableNotification$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return enableNotification(this.http, this.rootUrl, params, context);
  }

  /**
   * Enable Notification.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `enableNotification$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  enableNotification(params: EnableNotification$Params, context?: HttpContext): Observable<void> {
    return this.enableNotification$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `setMyNotificationAsRead()` */
  static readonly SetMyNotificationAsReadPath = '/api/notification/{notificationId}/markAsRead';

  /**
   * Set My Notification As Read.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setMyNotificationAsRead()` instead.
   *
   * This method doesn't expect any request body.
   */
  setMyNotificationAsRead$Response(params: SetMyNotificationAsRead$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return setMyNotificationAsRead(this.http, this.rootUrl, params, context);
  }

  /**
   * Set My Notification As Read.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `setMyNotificationAsRead$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  setMyNotificationAsRead(params: SetMyNotificationAsRead$Params, context?: HttpContext): Observable<void> {
    return this.setMyNotificationAsRead$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `setMyFacilityNotificationAsRead()` */
  static readonly SetMyFacilityNotificationAsReadPath = '/api/notification/{notificationId}/{facilityId}/markAsRead';

  /**
   * Set My Facility Notification As Read.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setMyFacilityNotificationAsRead()` instead.
   *
   * This method doesn't expect any request body.
   */
  setMyFacilityNotificationAsRead$Response(params: SetMyFacilityNotificationAsRead$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return setMyFacilityNotificationAsRead(this.http, this.rootUrl, params, context);
  }

  /**
   * Set My Facility Notification As Read.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `setMyFacilityNotificationAsRead$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  setMyFacilityNotificationAsRead(params: SetMyFacilityNotificationAsRead$Params, context?: HttpContext): Observable<void> {
    return this.setMyFacilityNotificationAsRead$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
